import { TablePaginationConfig } from "antd";
import { driversApi } from "api/driver";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { IDriver } from "models/driver";
import { ChangeEvent, useEffect, useState } from "react";

export default function useDriverSearch() {
  const { showError } = useNotificationContext();
  const { reloadDriver } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<IDriver>>({
    ...defaultTableData,
    loading: false,
  });

  useEffect(() => {
    if (data.search.trim().length > 0) fetchData();
    // eslint-disable-next-line
  }, [data.search, reloadDriver]);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await driversApi(
      data.page,
      data.per_page,
      data.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return { data, handlePageChange, handleSearch };
}
